import { fetchItems } from '../../../../support/queries';

export function getContentDisplayName(item: any) {
  if (item?.name) return String(item.name);
  if (item?.title) return String(item.title);
  return String(item?.id ?? '');
}

export async function loadProviderItems(endpoint?: string): Promise<any[]> {
  if (!endpoint) return [];
  try {
    const items = await fetchItems(endpoint);
    return Array.isArray(items) ? items : [];
  } catch {
    return [];
  }
}

type LoadDcloudCatalogItemsParams = {
  email: string;
  text: string;
  preferred_data_center?: string;
  page?: number;
  size?: number;
  searchType?: string;
  labType?: string;
};

function filterDcloudCatalogItems(items: any[], labType?: string) {
  const normalizedLabType = String(labType || 'instant_demo').trim().toLowerCase();

  return items.filter((entry) => {
    const contentType = String(entry?.contentType || '').trim().toLowerCase();

    if (normalizedLabType === 'instant_demo') {
      return contentType === 'instantdemo';
    }

    if (normalizedLabType === 'scheduled_lab') {
      return contentType === 'demo';
    }

    return true;
  });
}

function sortDcloudCatalogItems(items: any[]) {
  return [...items].sort((a, b) => {
    const aRelevance = Number(a?.relevance ?? 0);
    const bRelevance = Number(b?.relevance ?? 0);
    if (bRelevance !== aRelevance) return bRelevance - aRelevance;

    const aName = String(a?.name || a?.title || '');
    const bName = String(b?.name || b?.title || '');
    return aName.localeCompare(bName);
  });
}

export async function loadDcloudCatalogItems({
                                               email,
                                               text,
                                               preferred_data_center = 'rtp',
                                               page = 1,
                                               size = 1000,
                                               searchType,
                                               labType,
                                             }: LoadDcloudCatalogItemsParams): Promise<any[]> {
  const query = String(text || '').trim();
  if (!email || !query) return [];

  try {
    const response = await fetchItems(
      'dcloud/catalog/search',
      {
        page,
        size,
        text: query,
        email,
        preferred_data_center,
        search_type: searchType || 'text',
      },
      { includePageSize: false },
    );

    const content = Array.isArray(response?.content) ? response.content : [];
    const filtered = filterDcloudCatalogItems(content, labType);
    return sortDcloudCatalogItems(filtered);
  } catch {
    return [];
  }
}